<template>
<input class="time-input form-control ib" :style="{width:width}"
  :class="{'bg-blue': !readonly}"
  maxlength="2" v-model="inputValue" :readonly="readonly"
  @change="onChange"
  @blur="onBlur">
</template>

<script>
export default {
  name: 'time-input',
  props: {
    value: {
      type: [String, Number],
    },
    mode: {
      type: String,
      required: true,
      validator(val) {
        return ['hour', 'minute'].includes(val)
      },
    },
    dataType: {
      type: String,
      default: 'string',
      validator(val) {
        return ['string', 'number'].includes(val)
      },
    },
    maxHourRange: {
      type: Number,
      default: 23,
    },
    width: {
      type: String,
      default: '46px',
    },
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      inputValue: this.convVal(this.value),
    }
  },
  watch: {
    value() {
      this.inputValue = this.convVal(this.value)
    },
  },
  methods: {
    adjustValRange(val) {
      if (val === null || val === undefined) { return val }
      // 全角数字は強制的に半角へ変換
      const valStr = val.toString().replace(/[０-９]/g, (str) => {
        return String.fromCharCode(str.charCodeAt(0) - 0xFEE0)
      })
      let valInt = parseInt(valStr)
      if (!valStr.match(/^\d+$/)) { return null }
      if (isNaN(valInt)) { return null }

      if (this.mode === 'hour') {
        if (valInt < 0) { valInt = 0 }
        if (valInt > this.maxHourRange) { valInt = this.maxHourRange }
      } else if (this.mode === 'minute') {
        if (valInt < 0) { valInt = 0 }
        if (valInt > 59) { valInt = 59 }
      }
      return valInt
    },
    formatVal(val) {
      if (val === null || val === undefined) { return val }
      if (this.dataType === 'string') {
        val = val.toString()
        if (val.match(/^\d+$/)) {
          val = ('0' + val).slice(-2)
        }
      } else if (this.dataType === 'number') {
        val = parseInt(val)
        if (isNaN(val)) { val = 0 }
      }
      return val
    },
    convVal(val) {
      return this.formatVal(this.adjustValRange(val))
    },
    onChange($event) {
      this.inputValue = this.convVal(this.inputValue)
      this.$emit('input', this.inputValue)
    },
    onBlur($event) {
      // emit for vee-validate flags to be updated
      this.$emit('blur', $event)
    },
  },
}
</script>

<style lang="scss" scoped>
  .time-input.form-control {
    padding: 6px 12px;
  }
</style>
